import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=07c69387&scoped=true&"
import script from "./TaskManage.vue?vue&type=script&lang=js&"
export * from "./TaskManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c69387",
  null
  
)

export default component.exports